import React, { useEffect, useRef, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { localeStringConverter } from '../../helper/Converters';
import PrimaryButton from '../../components/ui/PrimaryButton';
import SecondaryButton from '../../components/ui/SecondaryButton';
import CreateAction from '../../components/operational/createAction';
import ThemeCard from '../../components/ui/ThemeCard';
// import ThemesModal from "../../pages/DashboardPages/ThemesModel.jsx";
import ThemesModal from '../../pages/DashboardPages/ThemesModel.jsx';
import QRCode from 'react-qr-code';
import { NameType } from 'recharts/types/component/DefaultTooltipContent';
import { SVG_Copy_Linear } from '@dev-mobligo/iconpack';
import ThemesModalLanguageSelect from './Modals/ThemesModalLanguageSelect';
import { Menu } from 'primereact/menu';
import { useSelector } from 'react-redux';
const ThemeSelect = () => {
  const navigate = useNavigate();
  const storeId = localStorage.getItem('activeStoreId');
  const license = useSelector((state: any) => state.myUserSlice?.license);
  const app = useSelector((state: any) => state.myAppsSlice?.localReduxData.app);
  const [themes, setTheme] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);

  const mainTheme: any = themes.find((theme: any) => theme.isMain && !theme.mainThemeId);
  const webViewThemes = themes?.filter(
    (theme: any) => !theme.mainThemeId && theme?.themeData?.[0]?.settings?.isWebView,
  );
  const scaleThemes = themes?.filter((theme: any) => !theme.mainThemeId && !theme?.themeData?.[0]?.settings?.isWebView);
  useEffect(() => {
    !isOpen && getThemes();
  }, [isOpen]);

  const getThemes = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/mainThemes`,
      showPreLoader: true,
      isFileUploading: false,
    });
    if (response?.error) return;
    const initialThemes = response?.result?.resultData;
    const sortedThemes = initialThemes?.map((theme: any) => {
      const isPublishable =
        !license?.cannotPublish &&
        !theme?.isMain &&
        (!license?.isWebView || theme?.themeData?.[0]?.settings?.isWebView);
      theme.isPublishable = isPublishable;
      return theme;
    });
    // localStorage.setItem("editingThemeId", themeId)
    setTheme(sortedThemes);
  };

  const setThemeId = () => {
    //@ts-ignore
    const activeTheme = themes.find(theme => theme.isMain);
    //@ts-ignore
    navigate(`/theme/${activeTheme?.id}`);
  };

  const setDraftToLiveAll = async () => {
    const response = await CreateAction({
      method: 'post',
      path: `/setDraftToLiveFromMainId/${mainTheme.id}`,
      showPreLoader: true,
      isFileUploading: false
    });

    if (response?.error) return
    getThemes()
    return { success: "" }
  }

  return (
    // <div className="top-0 absolute w-[100%-280px] h-[100%] justify-center bg-black">
    //     <ThemesModal />
    // </div>
    <div className="w-[100%] relative text-[#212121] overflow-auto  h-full">
      {isOpen && <ThemesModal isOpen={isOpen} setIsOpen={setIsOpen} />}
      <div className="bg-[#f5f5f5] flex flex-col p-[20px] items-center  pb-[20px] 2lx:pb-[40px]">
        <div className="w-[100%] border rounded-[10px] bg-white p-[45px] ">
          <div className="flex flex-col-reverse md:flex-row items-center content-center justify-center">
            <div className="w-[100%] md:w-[100%] text-sm flex flex-row justify-between">
              <div>
                <div className="flex items-center mb-[20px] gap-[15px]">
                  <span className="text-[#5E5873] text-[18px] ">{mainTheme?.name}</span>
                  <div className=" right-[15px] top-[15px] bg-[#E1D4FF] rounded-md py-[3px] px-[10px] py-[5px] text-[14px] text-[#7059ef]">
                    Yayındaki Tema
                  </div>
                </div>
                <div>
                  <span className="text-[15px] text-[#8A92A6] font-light" style={{ lineHeight: '24px' }}>
                    {mainTheme?.Theme?.description}
                  </span>
                  <div className="flex items-center gap-[10px]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path
                        d="M9 5.80005V9.00005L11 11"
                        stroke="#8A92A6"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        opacity="0.5"
                        d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1C12.7712 1 14.6569 1 15.8284 2.17157C17 3.34315 17 5.22876 17 9C17 12.7712 17 14.6569 15.8284 15.8284C14.6569 17 12.7712 17 9 17C5.22876 17 3.34315 17 2.17157 15.8284C1 14.6569 1 12.7712 1 9Z"
                        stroke="#8A92A6"
                        stroke-width="1.5"
                      />
                    </svg>
                    <div className="flex items-center gap-[3px]">
                      <span className="text-[#8A92A6] font-medium text-[14px]">Son Güncelleme:</span>
                      <span className="text-[14px] text-[#60646F]">{localeStringConverter(mainTheme?.updatedAt)}</span>
                    </div>
                  </div>
                </div>
              </div>


              <div className="flex items-center gap-[15px] h-min my-auto ">
                {mainTheme?.themeData?.filter((themeData: any) => themeData?.draftData)?.length > 0 && (
                  <>
                    <PrimaryButton
                      confirmationMessage={'isDraftPublish'}
                      classes={'text-[14px] !bg-green-600 py-[15px] px-[20px] h-[40px]'}
                      onClick={() => {
                        setDraftToLiveAll();
                      }}
                      value={'Temayı Güncelle'}
                    />
                  </>
                )}
                <PrimaryButton
                  classes='text-[16px]  w-[170px] h-[40px]'
                  onClick={() => {
                    setSelectOpen(true);
                  }}
                  value={'Temayı Düzenle'}
                />
              </div>
            </div>
            {/* <div className="w-[100%] md:w-[25%] flex flex-col items-center">
                            <img src={mainTheme?.Theme?.images} className="rounded-[2px]" />
                        </div> */}
          </div>
        </div>
        <div className="w-[100%] text-[#212121]  rounded-[10px] bg-white  mt-[20px] ">
          <div className="flex flex-col">
            <div className="flex flex-row items-center justify-between  p-[45px]">
              <div className="flex flex-col ">
                <div className="text-[18px]  text-[#5E5873]">Temalarım</div>
              </div>
              <PrimaryButton
                classes='w-[170px]'
                onClick={() => {
                  setIsOpen(true);
                }}
                value={'+ Tema Ekle'}
              />
            </div>
            <hr className="w-full h-px bg-gray-200 border-0 dark:bg-gray-700" />
            {webViewThemes?.length > 0 && (
              <div className="px-[45px] py-[30px]">
                Webview Temaları
                <div className="flex flex-col flex-wrap items-center mt-[30px]  border-2 rounded-2xl">
                  <div className="overflow-x-auto w-full items-start">
                    <div className="w-full ">
                      {webViewThemes
                        ?.sort((a: any, b: any) => {
                          const isActiveA = a?.updatedAt;
                          const isActiveB = b?.updatedAt;

                          // Compare based on the 'isActive' property
                          return isActiveB.localeCompare(isActiveA);
                        })
                        ?.sort((a: any, b: any) => {
                          // Convert boolean values to 1 or 0 for comparison
                          const isActiveA = a?.isPublishable ? 0 : 1;
                          const isActiveB = b?.isPublishable ? 0 : 1;

                          // Compare based on the 'isActive' property
                          return isActiveA - isActiveB;
                        })
                        ?.sort((a: any, b: any) => {
                          // Convert boolean values to 1 or 0 for comparison
                          const isActiveA = a?.isMain ? 0 : 1;
                          const isActiveB = b?.isMain ? 0 : 1;

                          // Compare based on the 'isActive' property
                          return isActiveA - isActiveB;
                        })
                        .map((theme: any, index: any) => {
                          return (
                            <ThemeCard getThemes={getThemes} themes={themes} setThemeId={setThemeId} theme={theme} />
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {scaleThemes?.length > 0 && (
              <div className="px-[45px] py-[30px]">
                <div className='flex flex-row justify-between'>
                  <span>Native Temaları</span>
                  {app.isDemo &&
                    <PrimaryButton classes='w-[170px]'
                      onClick={() => { navigate("/dashboard/theme-settings/integrations/provider") }} value={"Entegrasyon Yap"} />
                  }
                </div>
                <div className="flex flex-col flex-wrap items-center mt-[30px]  border-2 rounded-2xl">
                  <div className="overflow-x-auto w-full items-start">
                    <div className="w-full ">
                      {scaleThemes
                        ?.sort((a: any, b: any) => {
                          const isActiveA = a?.updatedAt;
                          const isActiveB = b?.updatedAt;

                          // Compare based on the 'isActive' property
                          return isActiveB.localeCompare(isActiveA);
                        })
                        ?.sort((a: any, b: any) => {
                          // Convert boolean values to 1 or 0 for comparison
                          const isActiveA = a?.isPublishable ? 0 : 1;
                          const isActiveB = b?.isPublishable ? 0 : 1;

                          // Compare based on the 'isActive' property
                          return isActiveA - isActiveB;
                        })
                        ?.sort((a: any, b: any) => {
                          // Convert boolean values to 1 or 0 for comparison
                          const isActiveA = a?.isMain ? 0 : 1;
                          const isActiveB = b?.isMain ? 0 : 1;

                          // Compare based on the 'isActive' property
                          return isActiveA - isActiveB;
                        })
                        .map((theme: any, index: any) => {
                          return (
                            <ThemeCard getThemes={getThemes} themes={themes} setThemeId={setThemeId} theme={theme} />
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {selectOpen && (
        <ThemesModalLanguageSelect
          getThemes={getThemes}
          themes={themes}
          theme={mainTheme}
          isOpen={selectOpen}
          setIsOpen={setSelectOpen}
        ></ThemesModalLanguageSelect>
      )}
    </div>
  );
};

export default ThemeSelect;
